import React from 'react'
import { Link } from 'react-router-dom'

const StoreNew = () => {
  return (
    <>
    {/* <div className='store-full'>        
        <div className='store-box'>
            <div className='store-box-wrap'>
                <span className="scrolldiv" id='newdelhi'></span>
                <div className='store-overlaytext'>
                    <div className='store-bigtext'>The Experience Center <small> New Delhi</small></div>
                    <div className='store-link'><span><Link to="/aboutchaashni#the-experience-center-new-delhi">Explore</Link> <Link to="https://chaashnicouture.com/book-appointment/" target='_blank'>Book an Appointment</Link></span></div>
                </div>
                <img src='/images/delhi-showroom.jpg' alt='The Experience Center New Delhi' />            
            </div>
        </div>
        <div className='store-box'>
            <div className='store-box-wrap'>
                 <span className="scrolldiv" id='dubai'></span>
                <div className='store-overlaytext'>
                    <div className='store-bigtext'>THE GULF FLAGSHIP <small> Dubai</small></div>
                    <div className='store-link'><span><Link to="/aboutchaashni#the-gulf-flagship-dubai">Explore</Link> <Link to="https://chaashnicouture.com/book-appointment/" target='_blank'>Book an Appointment</Link></span></div>
                </div>
                <img src='/images/dubai-showroom.jpg' alt='The Experience Center  Dubai' />            
            </div>
        </div>       
    </div> */}

    <div className="storenew-box new-design">
      <span className='newscroll-box' id="storenew-box">&nbsp;</span>
   <div className="container">
     <h2><em>The</em> Flagships and Experience Center</h2>
     <p>Delhi - Dubai - Bhopal</p>
  <div className="store-full">
    <div className="store-box">
      <div className="store-box-wrap"><span className="scrolldiv" id="newdelhi"></span>
        <div className="store-overlaytext">
          <div className="store-bigtext">The Experience Center <small> New Delhi</small></div>
          <div className="store-link"><span><a href="/aboutchaashni#the-experience-center-new-delhi">Explore</a> <a href="https://wa.me/+919873475454?text=Appointment" target="_blank">Book an Appointment</a></span></div>
        </div>
        <img src="/images/showroom/flagships-center/delhi-showroom.jpg" alt="The Experience Center New Delhi" /></div>
    </div>
    
    <div className="store-box">
      <div className="store-box-wrap"><span class="scrolldiv" id="dubai"></span>
        <div className="store-overlaytext">
          <div className="store-bigtext">THE GULF FLAGSHIP <small> Dubai</small></div>
          <div className="store-link"><span><a href="/aboutchaashni#the-gulf-flagship-dubai">Explore</a> <a href="https://wa.me/+971503848387?text=Appointment" target="_blank">Book an Appointment</a></span></div>
        </div>
        <img src="/images/showroom/flagships-center/dubai-showroom.jpg" alt="The Experience Center  Dubai" /></div>
    </div>
    
    <div className="store-box">
      <div className="store-box-wrap"><span className="scrolldiv" id="newdelhi"></span>
        <div className="store-overlaytext">
          <div className="store-bigtext">The Begum’s Courtyard <small> Bhopal</small></div>
          <div className="store-link">Coming Soon{/* <span><a href="/aboutchaashni#the-experience-center-new-delhi">Explore</a> <a href="https://chaashnicouture.com/book-appointment/" target="_blank">Book an Appointment</a></span> */}</div>
        </div>
        <img src="/images/showroom/flagships-center/bhopal-showroom.jpg" alt="The Experience Center Bhopal" /></div>
    </div>
  </div>
  <div className='flower-box'><img src='/images/newhome/flower-four.png' alt='' /></div>
  </div>
</div>

    </>
  )
}

export default StoreNew
